// extracted by mini-css-extract-plugin
module.exports = {"dltvAdminPanel":"src-DLTVAdminPanel-styles-style-module__dltvAdminPanel--3U_UA"};